export const ItalianRegions = [
    'all',
    'aosta_valley',
    'piedmont', 
    'lombardy', 
    'veneto', 
    'trentino_alto_adige', 
    'friuli_venezia_giulia',
    'liguria', 
    'emilia_romagna', 
    'tuscany', 
    'marche', 
    'umbria', 
    'lazio', 
    'abruzzo', 
    'molise', 
    'campania', 
    'apulia', 
    'basilicata', 
    'calabria', 
    'sicily',
    'sardinia',
]

export const ItalianRegionsCenter = {
    'all': {center: [12, 42], zoom: 1},
    'aosta_valley': {center: [7.5, 45.75], zoom: 8},
    'piedmont': {center: [7.75, 45.25], zoom: 4},
    'lombardy': {center: [9.75, 45.5], zoom: 4},
    'veneto': {center: [11.75, 45.75], zoom: 5},
    'trentino_alto_adige': {center: [11.25, 46.25], zoom: 6},
    'friuli_venezia_giulia': {center: [13.25, 46], zoom: 7},
    'liguria': {center: [8.75, 44.25], zoom: 5},
    'emilia_romagna': {center: [11, 44.5], zoom: 4},
    'tuscany': {center: [11.25, 43.25], zoom: 4},
    'marche': {center: [13, 43.25], zoom: 6},
    'umbria': {center: [12.5, 43], zoom: 6},
    'lazio': {center: [12.75, 42], zoom: 5},
    'abruzzo': {center: [13.75, 42.25], zoom: 6},
    'molise': {center: [14.5, 41.75], zoom: 8},
    'campania': {center: [14.75, 40.75], zoom: 5},
    'apulia': {center: [16.75, 40.75], zoom: 4},
    'basilicata': {center: [16, 40.5], zoom: 7},
    'calabria': {center: [16.25, 39], zoom: 4},
    'sicily': {center: [14, 37.5], zoom: 4},
    'sardinia': {center: [9, 40], zoom: 4},
}

export const getItalianRegionMenuItems = (tFunc) => {
    const italianRegionMenuItems = ItalianRegions.map((region, index) => {
        return {value: region, label: tFunc(`regions.${region}`)}
    })

    return italianRegionMenuItems
}


// WEBPACK FOOTER //
// ./src/libs/ItalianRegions.js